import { eventListener, TOPICS } from "@origin-digital/event-dispatcher";
import { fetchGeolocationFn, writeGeolocationFn } from "./utils/geolocation";

export const initGeoTargeting = () => {
  eventListener.addListener(TOPICS.FETCH_GEOLOCATION, fetchGeolocationFn);
  eventListener.addListener(TOPICS.WRITE_GEOLOCATION, writeGeolocationFn);
};
